import {
  Component,
  OnInit,
  HostListener,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { LookerAdminService } from 'src/app/services/looker-admin.service';

@Component({
  standalone: false,
  selector: 'app-rx-performance-summary',
  templateUrl: './rx-performance-summary.component.html',
  styleUrls: ['./rx-performance-summary.component.scss'],
})
export class RxPerformanceSummaryComponent implements OnInit {
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
    private lookerAdminService: LookerAdminService
  ) {}

  public serviceName: string = 'RXPerformance';
  public feature: string = 'UI::BusinessIntelligence::RxPerformance';
  public loadingStatus: boolean;
  public pageSize = 10;
  private routeSub: any;
  routeActivated = false;
  healthcareTopBarLoaded: Subscription;
  scroll: any;

  ngOnInit(): void {
    this.scroll = window.pageYOffset;
    const self = this;
  }

  routeChanged(): void {
    this.routeActivated = true;
    if (this.authorizationService.HealthcareTopBar) {
      this.authorizationService.HealthcareTopBar.notifyActivity();
    }
  }

  sideNavDashboardItemsComplete($event) {
    this.lookerAdminService.sendMessage($event);
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event): void {
    const prevScrollpos = window.pageYOffset;
    const currentScrollPos = window.pageYOffset;
    if (prevScrollpos <= 71) {
      document.getElementById('navbar').style.top = 71 - prevScrollpos + 'px';
    } else {
      document.getElementById('navbar').style.top = '0px';
    }
  }
}
